import { z } from "zod";
import { AgentRunKind, AgentRunState } from "@/gql/graphql";
import { createRoute } from "@tanstack/react-router";
import { AgentRunsScreen } from "@/app/Agents/Screens/AgentRunsScreen";
import { appLayoutRoute } from "@/routes/layout-routes";

const agentRunSearchParams = z.object({
  agentKind: z.enum(AgentRunKind).optional().catch(undefined),
  agentState: z.enum(AgentRunState).optional().catch(undefined),
});

export type AgentRunListSearchParams = z.infer<typeof agentRunSearchParams>;

export const agentRunsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/agents",
  component: AgentRunsScreen,
  validateSearch: agentRunSearchParams,
  head: () => ({
    meta: [
      { title: "Agents - Imoova Admin" },
      {
        name: "description",
        content: "What Imoova's agents have handled",
      },
    ],
  }),
});
